import { guidesLocales } from '@/config/locales';
import { mapApiDataToGuidesHome } from '@/lib/cms-mappers';
import { PAGE_SIZE } from '@/config/strapi-content';

import type { FGuidesHomeTemplateProps } from '@/components/templates/FGuidesHomeTemplate.vue';

/**
 * Returns guides data fetched from CMS (Strapi)
 */
export async function useCmsGuidesHome(): UseCmsResponse<FGuidesHomeTemplateProps> {
  const { t } = useI18n();
  const { data, error, pending, refresh } = await useStrapi('guides', {
    localesSubset: guidesLocales,
    queryParams: {
      populate: '*',
      pagination: {
        page: 0,
        pageSize: PAGE_SIZE,
      },
    },
  });

  const mappedData = computed(() => mapApiDataToGuidesHome(data.value?.data));
  const i18nMappedData = computed<FGuidesHomeTemplateProps>(() => ({
    cards: mappedData.value.cards.map(card => ({
      ...card,
      buttonText: t('resource_guides__card__button_text'),
    })),
  }));

  return { data: i18nMappedData, error, pending, refresh };
}
